import { SearchProps } from '~components/form-fields/search';

import { isEncryptionEnabled } from '~libs/encryptionSettings';

export const searchFields: SearchProps = {
  basic_search: {
    persist: true,
    type: 'text-like',
    field: ['first_name', 'surname'],
    placeholder: 'Basic Search',
    caption: 'Basic Search',
    hidden: isEncryptionEnabled,
  },
};

export default searchFields;
